(() => {
  const inRange = (value, range) => {
    const [min, max] = range.split('-').map(Number);
    return value >= min && value <= max;
  };

  const initMenu = () => {
    const button = document.querySelector('[data-mobile-menu-button]');
    const menu = document.querySelector('[data-mobile-menu]');
    if (!button || !menu || button.dataset.ready) return;
    button.dataset.ready = 'true';

    const setOpen = (open) => {
      menu.classList.toggle('open', open);
      button.setAttribute('aria-expanded', String(open));
      button.setAttribute('aria-label', open ? 'Cerrar menú' : 'Abrir menú');
      button.textContent = open ? '✕' : '☰';
    };

    button.addEventListener('click', () => setOpen(!menu.classList.contains('open')));
    menu.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => setOpen(false)));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') setOpen(false);
    });
  };

  const initFilters = (root = document) => {
    const controls = root.querySelector('[data-model-filters]');
    const cards = [...root.querySelectorAll('[data-model-card]')];
    const count = root.querySelector('[data-result-count]');
    const empty = root.querySelector('[data-filter-empty]');
    if (!controls || !cards.length || controls.dataset.ready) return;
    controls.dataset.ready = 'true';

    const apply = () => {
      const filters = [...controls.querySelectorAll('[data-filter]')];
      let visible = 0;
      cards.forEach((card) => {
        const show = filters.every((select) => {
          if (!select.value) return true;
          const value = Number(card.dataset[select.dataset.filter]);
          return select.value.includes('-') ? inRange(value, select.value) : value === Number(select.value);
        });
        card.classList.toggle('sf-card-hidden', !show);
        if (show) visible += 1;
      });
      if (count) count.textContent = `${visible} modelo${visible === 1 ? '' : 's'} disponible${visible === 1 ? '' : 's'}`;
      if (empty) empty.style.display = visible ? 'none' : 'block';
    };

    controls.querySelectorAll('[data-filter]').forEach((select) => select.addEventListener('change', apply));
    controls.querySelector('[data-filter-reset]')?.addEventListener('click', () => {
      controls.querySelectorAll('[data-filter]').forEach((select) => { select.value = ''; });
      apply();
    });
  };

  const initProduct = (root = document) => {
    const product = root.querySelector('[data-product-root]');
    if (!product || product.dataset.ready) return;
    product.dataset.ready = 'true';

    const mediaButtons = product.querySelectorAll('[data-media-button]');
    const mediaItems = product.querySelectorAll('[data-media-item]');
    mediaButtons.forEach((button) => button.addEventListener('click', () => {
      mediaItems.forEach((item) => { item.hidden = item.dataset.mediaItem !== button.dataset.mediaButton; });
      mediaButtons.forEach((item) => item.classList.toggle('active', item === button));
    }));

    const legal = product.querySelector('[data-product-legal]');
    const addButton = product.querySelector('[data-add-to-cart]');
    const price = product.querySelector('[data-product-price]');
    const variants = [...product.querySelectorAll('[data-variant-radio]')];
    const sync = () => {
      const selected = variants.find((variant) => variant.checked);
      const available = selected?.dataset.available === 'true';
      if (price && selected) price.textContent = selected.dataset.price;
      if (addButton) {
        addButton.disabled = !available || !legal?.checked;
        addButton.textContent = available ? 'Agregar al carrito' : 'No disponible';
      }
    };
    variants.forEach((variant) => variant.addEventListener('change', sync));
    legal?.addEventListener('change', sync);
    sync();
  };

  const initCart = (root = document) => {
    const form = root.querySelector('[data-cart-form]');
    if (!form || form.dataset.ready) return;
    form.dataset.ready = 'true';
    const legal = form.querySelector('[data-cart-legal]');
    const checkout = form.querySelector('[data-cart-checkout]');
    const sync = () => { if (checkout) checkout.disabled = !legal?.checked; };
    legal?.addEventListener('change', sync);
    sync();
  };

  const init = (root = document) => {
    initMenu();
    initFilters(root);
    initProduct(root);
    initCart(root);
  };

  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
